<template>
    <div>
        <div class="form-group form-group-32 mb-3">
            <label for="form-label">
                {{ filter.inputs.country.label }}
            </label>
            <div class="form-input block">
                <el-select
                    name="country"
                    filterable
                    v-model="country"
                    class="wp-10"
                    :placeholder="$t.__('listing.filters.LocationFilter.select_country')"
                    @change="reloadSubset"
                >
                    <el-option
                        v-for="option in countriesList"
                        :value="option.value"
                        :key="option.value"
                        :label="option.name"
                    >
                        {{ option.name }}
                    </el-option>
                </el-select>
            </div>
        </div>

        <div class="form-group form-group-32 block">
            <label for="form-label">
                {{ filter.inputs.value.label }}
            </label>
        </div>

        <div v-for="option in modes" :key="option.value">
            <div class="form-group">
                <label class="form-label label-auto" :for="'mode' + option.value">
                    <input
                        type="radio"
                        v-model="mode"
                        :value="option.value"
                        :id="'mode' + option.value"
                    />
                    {{ option.label }}
                </label>
            </div>

            <div class="form-group form-group-32" v-if="needValue && mode == option.value">
                <div class="form-input block">
                    <el-select
                        class="wp-10"
                        filterable
                        clearable
                        allow-create
                        v-model="value"
                        v-if="needSelectValue"
                        :multiple="selectMultiple"
                    >
                        <el-option
                            v-for="item in subset"
                            :value="item.value"
                            :label="item.label"
                            :key="`${option.value}${item.value}${item.label}`"
                        >
                            {{ item.label }}
                        </el-option>
                    </el-select>

                    <el-autocomplete
                        v-model="value"
                        :fetch-suggestions="searchLevel"
                        :trigger-on-focus="false"
                        :debounce="500"
                        clearable
                        allow-create
                        v-else
                        class="wp-10"
                        :placeholder="$t.__('common.labels.search')"
                    >
                        <template slot-scope="{ item }">
                            <div v-if="level == 'town'" class="flex-level">
                                <div class="flex ellipsis">
                                    {{ item.town }}
                                </div>
                                <small class="gray-60">{{ item.zipcode }}</small>
                            </div>
                            <div v-if="level == 'zipcode'" class="flex-level">
                                <div class="flex ellipsis">
                                    {{ item.zipcode }}
                                </div>
                                <small class="gray-60">{{ item.town }}</small>
                            </div>
                        </template>
                    </el-autocomplete>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],

    data() {
        return {
            country: '',
            mode: 'is',
            value: '',
            subset: [],
        };
    },

    mounted() {
        let countryHasProvince = _.findIndex(this.countriesList, { value: this.country }) != -1;
        if (this.level == 'state' && !countryHasProvince) {
            this.country = '';
        }
    },

    watch: {
        mode(newVal, oldval) {
            if ((oldval == 'is' || oldval == 'isnot') && newVal == 'exact' || oldval == 'contain' || oldval == 'startlike' || oldval == 'dontcontain') {
                this.value = '';
            }

            if (oldval == 'exact' && (newVal == 'is' || newVal == 'isnot' || oldval == 'contain' || oldval == 'startlike' || oldval == 'dontcontain')) {
                this.value = [];
            }
        },
    },

    computed: {
        data() {
            return {
                country: this.country,
                mode: this.mode,
                value: this.value,
            };
        },

        level() {
            return this.filter.inputs.value.type;
        },

        needValue() {
            const valueModes = ['exact', 'is', 'isnot', 'contain', 'startlike', 'dontcontain'];
            return valueModes.includes(this.mode);
        },

        needSelectValue() {
            const selectValueModes = ['is', 'isnot', 'contain', 'dontcontain', 'startlike'];
            return (['zipcode', 'state'].includes(this.level)) && selectValueModes.includes(this.mode)
        },

        selectMultiple() {
            return (
                this.level == 'zipcode' &&
                this.country == 'FR' &&
                ['exact','is', 'isnot'].includes(this.mode) &&
                this.needSelectValue
            );
        },

        countriesList() {
            let countries = this.filter.inputs.country.options;

            if (this.level == 'state') {
                return Object.values(countries).filter((country) => {
                    return country.hasProvince == 'Y';
                });
            }

            return countries;
        },

        modes() {
            let modes = this.filter.inputs.mode.options;

            // 2char Departments only available for france for now
            if (this.level == 'zipcode' && this.country != 'FR') {
                return Object.values(modes).filter((mode) => {
                    return mode.value != 'is' && mode.value != 'isnot';
                });
            }

            return modes;
        },
    },

    created() {
        if (!this.filter.active && !this.filter.pending) {
            this.country = this.$store.state.corp.countryCode;
        }
        this.loadSubSet();
    },

    methods: {
        searchLevel(queryString, cb) {
            if (queryString.length == 0) {
                cb([]);
                return;
            }

            axios
                .get(
                    `/?_f=address&action=autogeo&level=${this.level}&q=${queryString}&country=${this.country}`,
                )
                .then((response) => {
                    cb(response.data.result);
                });
        },

        loadSubSet() {
            if (this.level == 'zipcode') {
                this.loadDepartments(this.country).then((result) => {
                    this.subset = result;
                });
            } else if (this.level == 'state') {
                this.loadStates(this.country).then((result) => {
                    this.subset = result;
                });
            }
        },

        reloadSubset() {
            this.value = '';

            this.loadSubSet();
        },

        loadStates(country) {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: '/?_f=address',
                    method: 'POST',
                    data: {
                        action: 'loadStates',
                        country: country,
                    },
                    dataType: 'json',
                    success: function (json) {
                        resolve(json.states);
                    },
                });
            });
        },

        loadDepartments(country) {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: '/?_f=address',
                    method: 'POST',
                    data: {
                        action: 'loadDepartments',
                        country: country,
                    },
                    dataType: 'json',
                    success: function (json) {
                        resolve(json.departments);
                    },
                });
            });
        },
    },
};
</script>
